import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC3ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC3ByHealthTeamData {
	healthTeam?: HealthTeam;
	totalPregnantsAndPuerperals: number = 0;
	totalPregnantsAndPuerperalsScore: number = 0;
	maxPregnantsAndPuerperalsScore: number = 0;
	totalPuerperals: number = 0;
	totalPuerperalsScore: number = 0;
	maxPuerperalsScore: number = 0;
}

export async function getResumeIndicatorC3ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC3ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC3ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC3ByHealthTeamData>();
}
